<template>
  <div id="app">
    <router-view></router-view>
    <MessageError v-if="this.error.length > 0" :msg="this.error" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout } from 'timers';
import MessageError from './components/MessageError.vue';

export default {
  name: 'app',
  components: {
    MessageError,
  },
  data() {
    return {
      started: false,
      loadAttempts: 0,
      error: '',
      darkThemeMq: {},
    };
  },
  computed: {
    ...mapGetters(['jsonData', 'currentFloorIndex', 'currentRoomIndex', 'currentExhibit', 'currentGalleryItem', 'infoActive']),
    dataLoaded() {
      return this.jsonData !== null;
    },
    innerHeight() {
      return window.innerHeight;
    },
  },
  methods: {
    ...mapActions(['resetNavigation', 'fetchJsonData', 'setDarkmodeActive', 'setBackgroundPattern', 'setFloorIndex', 'setRoomIndex', 'setExhibit', 'setPlayerActive', 'setPlayerGalleryItem', 'setInfoActive', 'setPlayerAudioActive', 'setPlayerImage', 'resetData']),
    checkLoaded() {
      setTimeout(() => {
        if (this.dataLoaded) { // this.jsonData.title !== undefined) {
          this.$router.push({ name: 'Floor', params: { floorId: 0 } });
          this.started = true;
        } else if (this.loadAttempts < 5) {
          this.loadAttempts += 1;
          this.checkLoaded();
        } else {
          this.error = 'Daten konnten nicht geladen werden';
        }
      }, 2000);
    },
    adjustColorScheme(isDark) {
      if (process.env.VUE_APP_DEBUG === 'on') {
        const newColorScheme = isDark ? 'dark' : 'light';
        if (process.env.VUE_APP_DEBUG === 'on') console.log(`preferes color scheme: ${newColorScheme}`);
      }
      this.setDarkmodeActive(isDark);
      this.adjustPatternColor();
    },
    adjustPatternColor() {
      const appBackgroundColor = this.$helper.trim(getComputedStyle(document.documentElement).getPropertyValue('--main-background-color'));
      this.setBackgroundPattern(`url("data:image/svg+xml,%3Csvg version='1.1' viewBox='0 0 10.93 10.93' xmlns='http://www.w3.org/2000/svg' fill='%23${appBackgroundColor.toString().substring(1)}'%3E%3Cpath transform='scale(.26458)' d='m3.0996 0-3.0996 3.0996v3.7871l6.8867-6.8867zm6.8867 0-9.9863 9.9863v3.7852l13.771-13.771zm6.8848 0-16.871 16.871v3.7871l20.658-20.658zm6.8848 0-23.756 23.756v3.7871l27.543-27.543zm6.8848 0-30.641 30.643v3.7852l34.428-34.428zm6.8867 0-37.527 37.527v3.7832h0.0039062l41.305-41.305v-0.0058594zm3.7812 3.1035-38.207 38.207h3.7871l34.42-34.42zm0 6.8848-31.32 31.322h3.7871l27.533-27.533zm0 6.8867-24.436 24.436h3.7871l20.648-20.648zm0 6.8848-17.551 17.551h3.7871l13.764-13.764zm0 6.8848-10.666 10.666h3.7891l6.877-6.877zm0 6.8867-3.7793 3.7793h3.7793z'/%3E%3C/svg%3E%0A")`);
    },
    adjustResize() {
      // viewport height adjust for iOS-Safari
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    setNavigation(params) {
      if (this.infoActive) {
        this.setInfoActive(false);
      }
      if (params.floorId !== undefined && parseInt(params.floorId, 10) !== this.currentFloorIndex) {
        this.setFloorIndex(parseInt(params.floorId, 10));
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from setNavigation');
      }
      if (params.roomId !== undefined && parseInt(params.roomId, 10) !== this.currentRoomIndex) {
        this.setRoomIndex(parseInt(params.roomId, 10));
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from setNavigation');
      } else if (params.roomId === undefined && this.currentFloorIndex !== null) {
        this.setRoomIndex(null);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from setNavigation');
      }
      if (params.exhibitId !== undefined
        && (this.currentExhibit === null
          || parseInt(params.exhibitId, 10) !== this.currentExhibit.id)) {
        this.setExhibit(this.jsonData.floors[this.currentFloorIndex]
          .rooms[this.currentRoomIndex].exhibits[parseInt(params.exhibitId, 10)]);
        this.setPlayerActive(true);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from setNavigation');
      } else if (params.exhibitId === undefined && this.currentExhibit !== null) {
        this.setExhibit(null);
        this.setPlayerActive(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from setNavigation');
      }
    },
  },
  watch: {
    $route(to, from) {
      // console.log(from.path);
      // console.log(to.path);
      /* if (this.$route.path === '/') {
        window.location.reload();
      } */
      if (to.path !== from.path && this.$route.path !== '/' && to.params !== undefined) {
        this.setNavigation(to.params);
      }
    },
    innerHeight() {
      setTimeout(() => {
        this.adjustResize();
      }, 500);
      console.log('inner height');
    },
  },
  created() {
    if (this.jsonData === null || this.jsonData === undefined) {
      this.fetchJsonData();
    } else {
      this.resetData();
    }
    if (this.$route.path.length > 1) {
      this.$router.push({ path: '/' });
    }
    this.adjustResize();
  },
  mounted() {
    this.checkLoaded();
    this.adjustPatternColor();
    /* setTimeout(() => {
      document.body.scrollTop = 3;
      // this.setRoomIndex(1);
    }, 1000); */

    // Register listeners
    window.matchMedia('(prefers-color-scheme: dark)').addListener((MediaQueryList) => {
      this.adjustColorScheme(MediaQueryList.matches);
    });
    window.matchMedia('(orientation: portrait)').addListener(() => {
      this.adjustResize();
      setTimeout(() => {
        this.adjustResize();
      }, 500);
      // console.log('Orientation changed');
    });
    // window.addEventListener('resize', () => this.adjustResize());
    /* window.onorientationchange = () => {
      setTimeout(() => {
        this.adjustResize();
      }, 500);
      console.log('onorientationchange');
    }; */
  },
};
</script>

<style lang="scss">
.dark {
  color:#333;
}
html, body {
  margin:0;
  border:0;
  padding:0;
}
body {
  color: #333;
  background-color: #ddd;
  color:var(--main-text-color);
  /* background-color: var(--main-background-color); */
  transition: background-color .5s ease;
  background-color: var(--theme-color);
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
p {
  line-height:1.4;
}
* {
  -ms-overflow-style:none; /* Hide scrollbar IE and Edge */
  scrollbar-width:none; /* Hide scrollbar Firefox */
  -webkit-touch-callout:none; /* iOS Safari */
   -webkit-user-select:none; /* Safari */
    -khtml-user-select:none; /* Konqueror HTML */
      -moz-user-select:none; /* Firefox */
       -ms-user-select:none; /* Internet Explorer/Edge */
           user-select:none; /* Non-prefixed version, currently
                                 supported by Chrome and Opera */
}
*::-webkit-scrollbar { /* Hide scrollbar Chrome, Safari and Opera */
  display:none;
}
.noClick {
  pointer-events:none;
}
#app {
  position:fixed;
  top: 0;
  left: 0;
  overflow:hidden;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  font-family:Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
  font-size:1rem;
  text-align:left;
  background-color: var(--main-background-color);
}
</style>
